<template>
    <div class="user-lists-item">

        <a :href="`/${currentList.user.username}/list/${currentList.slug}`">
            <span v-html="currentList.feature_image_html"></span>
            <div class="list-cover__loader" :class="{ 'is-loading': uploadingCover }">
                <div class="spinner"></div>
            </div>
        </a>

        <div class="content">
            <h3 v-text="currentList.name"></h3>
            <span v-text="currentList.destinations_text"></span>
        </div>

        <div class="user-lists-item__details">
            <a :href="`/${currentList.user.username}`">
                <img :src="currentList.user.md_avatar">
            </a>
            <div>
                By <a  :href="`/${currentList.user.username}`" class="person-hover-trigger" :data-user="currentList.user.username">
                {{ currentList.user.full_name }}</a>
                <br>
                Updated {{ diffForHumans(currentList.updated_at) }}
            </div>
        </div>

        <div class="user-lists-item__buttons" v-if="currentList.user_id == currentUser.id">

            <div class="lock-icon" v-if="currentList.secret">
                <svg class="lock-icon"><use xlink:href="#lock"></use></svg>
            </div>

            <!-- Dropdown Toogle -->
            <button class="user-lists-item-menu-trigger" @click="setActive()">
                <svg class="user-lists-item-menu-trigger"><use xlink:href="#dotdotdot"></use></svg>
            </button>

            <!-- Dropdown Menu -->
            <div class="user-lists-item__menu" :class="{ 'active': isActive }">

                <!-- Upload Cover Image button -->
                <update-cover v-model="currentList" @uploading-cover="uploadingCover = $event"></update-cover>

                <!-- Delete List -->
                <button @click="deleteList()">
                    <span><svg class="delete"><use xlink:href="#delete"></use></svg></span>
                    Delete List
                </button>

                <!-- Copy URL -->
                <button v-if="!currentList.secret"
                        class="list-copy-trigger"
                        :data-clipboard-text="url(`/${currentList.user.username}/list/${currentList.slug}`)"
                        @click="copyListLink()">

                    <span><svg class="copy"><use xlink:href="#copy"></use></svg></span>
                    {{  copyText }}
                </button>

                <!-- Edit List -->
                <button @click="updateList()">
                    <span><svg class="pen"><use xlink:href="#pen"></use></svg></span>
                    Edit List
                </button>

            </div>

            <div class='user-lists-item-shade' @click="setInactive()"></div>
        </div>


        <div class="user-lists-item__buttons" v-if="currentList.user_id != currentUser.id">

            <button class='user-lists-item-menu-trigger' @click="setActive()">
                <svg class='dotdotdot'><use xlink:href="#dotdotdot"></use></svg>
            </button>

            <div class='user-lists-item__menu' :class="{ 'active': isActive }">
                <button @click="unfollowList()">
                    <span><svg class='delete'><use xlink:href="#delete"></use></svg></span>
                    Unfollow
                </button>
            </div>

            <div class='user-lists-item-shade' @click="setInactive()"></div>
        </div>

    </div>
</template>
<script>

import UpdateCover from './UpdateCover'
import Helpers from '@/mixins/Helpers'

export default {

    mixins: [Helpers],

    props: ['value', 'index', 'currentUser'],

    components: {
        UpdateCover,
    },

    data() {
        return {
            copyText: 'Copy Share Link',
            uploadingCover: false,
            currentList: this.value,
            isActive: false,
        }
    },

    created() {
        eventBus.$on('set-list-active', event => {
            if (this.currentList.id != event.list.id) {
                this.setInactive()
            }
        });

        eventBus.$on('set-all-list-inactive', () => this.setInactive());
    },

    methods: {

        copyListLink(list) {
            this.copyText = 'Copied!';
        },

        deleteList() {
            this.isActive = false;
            eventBus.$emit('open-delete-list-modal', this.currentList);
        },

        unfollowList() {
            this.isActive = false;
            eventBus.$emit('open-unfollow-list-modal', this.currentList);
        },

        updateList() {
            this.isActive = false;
            eventBus.$emit('open-update-list-modal', this.currentList);
        },

        setActive() {
            this.isActive = true;
            this.selectedIndex = this.index
            eventBus.$emit('set-list-active', {
                listIndex: this.index,
                list: this.currentList
            });
        },

        setInactive() {
            this.isActive = false;
        },
    },

    watch: {
        value() {
            this.currentList = this.value
        }
    }
}
</script>
